var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedInIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#0A66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.13375 18H5.23125V8.65312H8.13375V18ZM6.68094 7.37812C5.75281 7.37812 5 6.60937 5 5.68124C5 5.23543 5.1771 4.80788 5.49234 4.49264C5.80757 4.1774 6.23513 4.00031 6.68094 4.00031C7.12675 4.00031 7.5543 4.1774 7.86954 4.49264C8.18478 4.80788 8.36188 5.23543 8.36188 5.68124C8.36188 6.60937 7.60875 7.37812 6.68094 7.37812ZM18.9969 18H16.1006V13.45C16.1006 12.3656 16.0787 10.975 14.5916 10.975C13.0825 10.975 12.8513 12.1531 12.8513 13.3719V18H9.95188V8.65312H12.7356V9.92812H12.7762C13.1637 9.19374 14.1103 8.41874 15.5225 8.41874C18.46 8.41874 19 10.3531 19 12.8656V18H18.9969Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIcon);
export default __webpack_public_path__ + "static/media/linkedIn-icon.66c73b8a2af5dc69fda884d8aa3ca3e9.svg";
export { ForwardRef as ReactComponent };